<template>
  <div class="footer-fullWrapper">
    <div class="footer-wrapper">
      <v-col cols="12" md="5">
        <div>
          <div class="footer-colTitle">{{ $t('footerLand.colTitle1') }}</div>
          <div class="d-flex align-center mb-3">
            <EmailIcon /> <span class="footer-text"> {{ $t('footerLand.footerTxt1') }}</span>
          </div>
          <div class="d-flex">
            <PhoneIcon /> <span class="footer-text">{{ $t('footerLand.footerTxt2') }}</span>
          </div>
        </div>

        <!-- <div class="footer-insText mt-5">
          Манай бүтээгдэхүүнүүдийн мэдээллийг цаг алдалгүй авахыг<br
            class="d-none d-md-flex"
          />
          хүсвэл манай жагсаалтад бүртгүүлээрэй!
        </div>
        <div class="footer-subEmailWrapper">
          <input
            type="text"
            autocomplete="off"
            placeholder="Э-мэйл хаяг"
            name="subEmail"
            v-model="email"
          />
          <span v-if="inputError == true" class="footer-errorInput">{{
            inputErrorText
          }}</span>
          <v-btn class="footer-subButton" @click="subscribeEmail">
            Бүртгүүлэх
          </v-btn>
        </div> -->
        <div style="margin-top:20px;">
          <div class="footer-socialsWrapper">
            <a class="mr-3" :href="item.url" v-for="(item, index) in socials" :key="item.url + index" target="_blank">
              <img :src="item.src" :alt="item.alt" />
            </a>
          </div>
          <div class="footer-copyright">
            {{ $t('footerLand.copyRight') }}
          </div>
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <div class="footer-colTitle">{{ $t('footerLand.colTitle2') }}</div>
        <div><a href="/service" class="footer-link">{{ $t('footerLand.link1') }} </a>
        </div>
        <!-- <div>
          <a class="footer-link">{{ $t('footerLand.link2') }}</a>
        </div> -->
        <div>
          <a href="/plan" class="footer-link">{{ $t('footerLand.link3') }}</a>
        </div>
      </v-col>
      <v-col cols="12" md="4">
        <div class="footer-colTitle">{{ $t('footerLand.colTitle3') }}</div>
        <div class="footer-insText">
          {{ $t('footerLand.footerInsText') }}
        </div>
      </v-col>
    </div>
  </div>
</template>
<script>
import EmailIcon from "../components/icons/EmailIcon";
import PhoneIcon from "../components/icons/PhoneIcon";
export default {
  name: "FooterLand",
  components: { EmailIcon, PhoneIcon },
  data: () => ({
    email: "",
    inputErrorText: "",
    inputError: false,
    socials: [
      {
        url: "https://www.facebook.com/chimegesystems",
        alt: "facebook",
        src: "/assets/icons/facebook.svg",
      },
      {
        url: "https://twitter.com/chimegesystems",
        alt: "twitter",
        src: "/assets/icons/twitter.svg",
      },
      {
        url: "https://www.youtube.com/channel/UCSaval6E1xTgRvKjtNaxwkA",
        alt: "youtube",
        src: "/assets/icons/youtube.svg",
      },
      {
        url: "https://instagram.com/chimege.systems",
        alt: "instagram",
        src: "/assets/icons/instagram.svg",
      },
    ],
  }),
  watch: {
    email: function () {
      if (this.email.length == 0) {
        this.inputErrorText = "Э-мэйл оруулна уу";
        this.inputError = true;
      } else {
        this.inputErrorText = "";
        this.inputError = false;
      }
    },
  },
  methods: {
    validateEmail() {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.email).toLowerCase());
    },
    subscribeEmail() {
      if (this.validateEmail()) {
        console.log("add");
      } else {
        this.inputErrorText = "Зөв э-мэйл оруулна уу";
        this.inputError = true;
      }
    },
  },
};
</script>
<style scoped>
.footer-fullWrapper {
  display: flex;
  width: 100%;
  min-height: 380px;
  background-color: #777ff6;
  justify-content: center;
  padding: 43px 10px;
}

.footer-wrapper {
  display: flex;
  flex-wrap: wrap;
  max-width: 1140px;
  width: 100%;
  height: 100%;
}

.footer-colTitle {
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  color: #ffffff;
  text-transform: uppercase;
  margin-bottom: 20px;
}

.footer-text {
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  color: #ffffff;
  margin-left: 10px;
}

.footer-insText {
  font-size: 12px;
  line-height: 14px;
  color: #ffffff;
}

.footer-emailWrapper {
  display: flex;
}

.footer-subEmailWrapper {
  display: flex;
  position: relative;
  height: 33px;
  margin: 20px 0 30px 0;
  width: 78%;
}

.footer-subEmailWrapper input[type="text"] {
  /* height: 40px; */
  padding-left: 15px;
  padding-right: 15px;
  font-size: 11px;
  line-height: 13px;
  font-weight: 400;
  border: 2px solid #777ff6;
  border-radius: 5px;
  float: left;
  width: 100%;
  background-color: #ffffff;
  color: #1f2d3d;
  transition: 0.4s ease-out;
}

.footer-subEmailWrapper input[type="text"]:focus {
  border: 2px solid #e5e5e5 !important;
  outline: none;
}

.footer-subEmailWrapper input[type="text"]:hover {
  border: 2px solid #e5e5e5 !important;
  transition: 0.4s ease-out;
  outline: none;
}

.footer-errorInput {
  font-size: 12px;
  line-height: 14px;
  color: red;
  position: absolute;
  bottom: -15px;
  left: 10px;
}

.footer-subButton {
  background-color: #000000 !important;
  text-transform: uppercase;
  color: #ffffff !important;
  border-radius: 5px;
  box-shadow: none;
  font-weight: 500;
  font-size: 11px;
  line-height: 13px;
  outline: none;
  margin-left: 13px;
  height: 33px !important;
  width: 93px !important;
}

.footer-socialsWrapper {
  display: flex;
  margin-bottom: 10px;
}

.footer-copyright {
  font-size: 11px;
  line-height: 13px;
  color: #ffffff;
}

.footer-link {
  font-size: 11px;
  line-height: 13px;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 14px;
  transition: all 0.3s;
  cursor: pointer;
  text-decoration: none;
}

.footer-link:hover {
  text-decoration: underline;
  transition: all 0.3s;
}

.footer-col {
  display: flex;
  flex-direction: column;
  height: 294px;
  justify-content: space-between;
}

@media screen and (max-width: 960px) {
  .footer-wrapper {
    justify-content: center;
    align-items: center;
  }

  .footer-subEmailWrapper input[type="text"] {
    width: 240px;
  }

  .footer-col {
    height: auto;
  }
}

@media screen and (max-width: 599px) {
  .footer-subEmailWrapper {
    width: 100%;
  }

  .footer-subEmailWrapper input[type="text"] {
    width: calc(100% - 106px);
  }
}
</style>
